import { useMutation } from '@tanstack/react-query';

import { useApiClient } from '../../../hooks';

const useDeleteOrganizationMutation = (accessToken) => {
  const apiClient = useApiClient(accessToken);
  const mutation = useMutation((organizationId) =>
    apiClient.delete(`/membership/organizations/${organizationId}`)
  );

  return mutation;
};

export { useDeleteOrganizationMutation };
